var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseValidationProvider',{attrs:{"rules":_vm.rules,"label":_vm.label,"label-for":_vm.$attrs.id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('BaseDatepicker',{class:['input', errors.length ? 'input-error' : ''],attrs:{"value":_vm.$attrs.value},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }